import moment from "moment-timezone";
import { getUserTimeZone } from ".";

const formatDateTime = (dt, format = "DD MMM YYYY hh:mm A", showUTC = false, tzString) => {
  if (!dt) return null;
  const momentDate = moment.utc(new Date(dt));
  if (showUTC) {
    momentDate.tz("UTC");
  } else {
    const timeZone = getUserTimeZone(tzString);
    momentDate.tz(timeZone.zone);
  }
  const formatted = momentDate.format(format);
  return formatted;
};
const safeFormatDateTime = (date, format, showUTC, tzString) => {
  try {
    const formattedDate = formatDateTime(date, format, showUTC, tzString);
    if (formattedDate === "Invalid date") {
      throw new Error("Invalid date");
    }
    return formattedDate;
  } catch (error) {
    return "";
  }
};

const combineDateTimeToISO = (date, time) => {
  return `${date}T${time}:00Z`;
};

export { formatDateTime as default, safeFormatDateTime, combineDateTimeToISO };
